module.exports = __webpack_public_path__ + "img/gdq_gbt7245_1987.prt.fab286aa.jpg";